exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal .modal-huge{max-width:900px;width:900px;max-height:500px;height:500px}.modal-backdrop{background:#002646a8}.modal-content{border:0;border-radius:20px;border:1px solid #e0e0e0}.modal-body,.modal-header{box-shadow:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ebd8b3f0","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Inicio/Plataforma.vue
// module id = 1109
// module chunks = 0